import { configureStore } from '@reduxjs/toolkit';
import referralsReducer from './features/referrals/referralsSlice';
import cancelSubscriptionReducer from './features/cancelSubscription/cancelSubscriptionSlice';

const store = configureStore({
  reducer: {
    referrals: referralsReducer,
    cancelSubscription: cancelSubscriptionReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export { store };
